import { IBackendCartEntries } from '@rbi-ctg/menu';
import { useGetUniquePurchasedItemsQuery } from 'generated/rbi-graphql';
import { withSimpleCache } from 'state/graphql/with-simple-cache';
import AuthStorage from 'utils/cognito/storage';
import { StorageKeys } from 'utils/local-storage';

export const NUM_RECENT_PURCHASED_ITEMS = 10;

const cachedGetUniquePurchasedItemsQuery = withSimpleCache(useGetUniquePurchasedItemsQuery);

/** returns unique purchased items when mounted. Will get fresh once per session, subsequent mounts will be from memory */
export const useUniquePurchasedItems = () => {
  const { data, loading } = cachedGetUniquePurchasedItemsQuery({
    skip: !AuthStorage.getItem(StorageKeys.USER_AUTH_TOKEN),
    variables: { numUniquePurchasedItems: NUM_RECENT_PURCHASED_ITEMS },
  });

  return {
    uniquePurchasedItems: (data?.me?.uniquePurchasedItems as unknown) as
      | IBackendCartEntries[]
      | null,
    loading,
  };
};
